import { designSystem } from '@/styles/styles';
import { PromotionThemeDocument } from '@/types/prismic.generated';
import { ColorField } from '@prismicio/client';

export const DEFAULT_PROMO_THEME = {
    background_color: designSystem.colors.neutral,
    promo_title_color: designSystem.colors.neutral700,
    expiration_tag_color: designSystem.colors.neutral700,
    secondary_button_text_color: designSystem.colors.neutral700,
    primary_button_background_color: designSystem.colors.neutral700,
    primary_button_text_color: designSystem.colors.neutral,
    top_glow_color: designSystem.colors.white,
    bottom_glow_color: designSystem.colors.neutral700,
    navigation_button_color: designSystem.colors.neutral700,
} as PromotionThemeDocument['data'];

/**
 * Used to get the colors of the theme as strings.
 * Needed because the ColorField type from prismic can be either a string or null, but we know we always
 * have a color because we fallback to the default theme
 * @param theme
 * @returns
 */
export const usePromoTheme = (theme?: PromotionThemeDocument['data']) => {
    const usedTheme = theme ?? DEFAULT_PROMO_THEME;
    return Object.entries(usedTheme).reduce((acc, [key, value]) => {
        if (value && typeof value === 'string') {
            acc[key as keyof typeof usedTheme] = value as ColorField<'filled'>;
        }
        return acc;
    }, {} as Record<keyof typeof usedTheme, ColorField<'filled'>>);
};
